<template lang="pug">
#modal-sucessfully-sent.modal.modal-md.fade(
  tabindex='-1',
  aria-labelledby='modalSucessfullySent',
  aria-hidden='true'
)
  .modal-dialog
    .modal-content.modal-component
      .modal-header.header
        .w-100.d-flex.align-items-center.justify-content-between
          span.fs-5.fw-semibold Sucesso!
          button#btnCloseModal.btn-close(
            type='button',
            data-bs-dismiss='modal',
            aria-label='Close'
          )
      .modal-body.d-flex.flex-column.gap-3
        .d-flex.flex-column.align-items-center
          img.success-image.mb-4(
            src='@/assets/images/success-view.svg',
            alt='success-view'
          )
          span
          | Recebemos seus documentos com sucesso!
          | Agora é só aguardar o retorno
          | de um de nossos agentes.
      .modal-footer
        .w-100.d-flex.justify-content-between
          button.btn.btn-outline-primary(
            type='button',
            data-bs-dismiss='modal',
            aria-label='Close'
          )
            | Enviar mais documentos
          button.btn.btn-primary(
            @click='redirect',
            data-bs-dismiss='modal',
            aria-label='Close'
          )
            span Sair
            Icon.ms-2(name='right-from-bracket')
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Atoms/Icon.vue'

  export default defineComponent({
    name: 'ModalSuccessfullySent',
    components: {
      Icon,
    },
    methods: {
      redirect() {
        this.$router.push('/')
      },
    },
  })
</script>

<style lang="stylus" scoped>
  .modal-component
    height: auto
    overflow-y: auto
  .modal-content
    background-color: #FCFCFC
  .success-image
    width: 200px
    height 200px
</style>
